// @flow weak
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../fetchTools';

// Lightweight session check against the backend (mirrors finance_portal's
// use of the same endpoint) -- source of truth for login state instead of
// trusting a localStorage flag.
export const getAuthStatus = () => {
  const url = `${getLocationOrigin()}/auth/auth_status`;
  const options = {...defaultOptions};

  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};



// WEBPACK FOOTER //
// ./src/app/services/API/authStatus.js